export default "__VITE_ASSET__a84eccb8__"